enum TaskGrouping {
  BY_DOSSIER = 'byDossier',
  NONE = 'none',
}

export default TaskGrouping;
